import React, { useState, useRef } from 'react'
import styled from 'styled-components'
import { useClickAway } from 'react-use'

import mailIcon from '../../images/mailbox.svg'

const MailWraper = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  margin-left: 30px;
  height: 100px;
  button {
    display: flex;
    border: none;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background-color: transparent;
    cursor: pointer;
    img {
      transition: 0.3s all ease-in-out;
    }
    span {
      padding: 0 5px;
    }
    .img {
      transform: rotate(180deg);
    }
    &:focus {
      outline: none;
    }
  }
  .iframe-wraper {
    width: 340px;
    position: absolute;
    top: 100px;
    right: 0;
    height: 378px;
    box-sizing: border-box;
    border: 1px solid #e4e7ed;
    transition: 0.3s all ease-in-out;
    border-top-width: 5px;
    opacity: 0;
    pointer-events: none;
  }
  .show {
    opacity: 1;
    pointer-events: all;
  }
  @media (max-width: 768px) {
    display: none;
  }
`

const AliyunMail = () => {
  const ref = useRef(null)
  const [status, setStatus] = useState(false)
  useClickAway(ref, () => {
    setStatus(false)
  })
  return (
    <MailWraper ref={ref}>
      <button onClick={() => setStatus(!status)}>
        <img width="20px" src={mailIcon} alt="企业邮局" />
      </button>
      <div className={status ? 'iframe-wraper show' : 'iframe-wraper'}>
        <iframe
          allowtransparency="true"
          title="AliyunMail"
          src="https://mailsso.mxhichina.com/dingdinglogin/loginByDingQrCode.htm?app_code=smartmail&amp;domain_name=qiye.aliyun.com&amp;lang=zh_CN&amp;network_env=1&amp;redirect_url=https%3A%2F%2Fqiye.aliyun.com%2Falimail%2Fauth%2FcallbackForCore%3Freurl%3D%252Falimail%252F&amp;sign=51c1313f895e8148f336e9e38755cb64"
          style={{ width: '338px', height: '378px' }}
          frameBorder="0"
        />
      </div>
    </MailWraper>
  )
}

export default AliyunMail
